import type { getSearchVariables } from '../getSearchVariables/getSearchVariables';
import { DATERANGES } from '#lib/websites/news/constants/dateranges.js';

export const isArtistActive = ({
	searchArtist,
	variables,
}: {
	searchArtist: string;
	variables: ReturnType<typeof getSearchVariables>;
}) => {
	const artist = variables['artist'];

	return (
		variables.daterange === DATERANGES.ALL &&
		artist?.toLowerCase() === searchArtist?.toLowerCase()
	);
};
